import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

import { CenteredImageWrapper, Image } from '../styles';

export const GalleryWrapper = styled.div`
  display: grid;

  width: 100%;

  grid-template-columns: repeat(2, 1fr);

  gap: 16px;

  ${QUERIES.tabletAndUp} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${QUERIES.largeTabletAndUp} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${QUERIES.laptopAndUp} {
    gap: 24px;
  }
`;

export const Menu = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;

  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 8px 16px;

  transform: translateY(100%);

  background: ${themeStyle.darkBackgroundAlt};

  transition: 0.2s transform;
`;

export const LoadingImage = styled(Image)<{ blur?: boolean }>`
  transition: 0.3s all;

  filter: ${({ blur }) => (blur ? 'blur(15px)' : 'none')};
`;

export const Wrapper = styled(CenteredImageWrapper)`
  box-shadow: ${themeStyle.varShadowSoft};
  border-radius: ${themeStyle.radiusMedium};

  overflow: hidden;
`;

export const Tile = styled.div<{ isLoading: boolean }>`
  position: relative;
  cursor: ${({ isLoading }) => (isLoading ? 'unset' : 'pointer')};

  &:hover {
    ${Menu} {
      transform: none;
    }

    ${LoadingImage} {
      ${({ isLoading }) =>
        !isLoading &&
        `
          transform: scale(1.1);
      `}};
    }
  }
`;
